import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import styles from './ProgramCost.module.scss';
export interface ProgramCostSummaryItem {
  label: ReactNode;
  value: ReactNode;
}
export interface ProgramCostProps {
  /** The tuition and fees summary: a `<dl>`, one row per item, in order. */
  summary: readonly ProgramCostSummaryItem[];
  /** The copy between the summary and the table. */
  children?: ReactNode;
  /** The cost table: a DataTable. */
  table?: ReactNode;
  /** The notes under the table. */
  fineprint?: ReactNode;
}

/**
 * A program's cost block (Phase 5 PR 5.0, incubating): the tuition and fees
 * summary as a `<dl>` of `<div><dt/><dd/></div>` rows (the paralegal page's
 * markup), then the page's copy, its cost table and its fine print. No
 * heading: the page keeps its own heading and level. The figures stay in
 * utils/programCosts.js; Helios renders what it is given. Cost is
 * compliance content: every part keeps its order. No `className` or `style`.
 */
function ProgramCost(t0) {
  const $ = _c(15);
  const {
    summary,
    children,
    table,
    fineprint
  } = t0;
  let t1;
  if ($[0] !== summary) {
    t1 = summary.map(_temp);
    $[0] = summary;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <dl className={styles["helios-program-cost__summary"]}>{t1}</dl>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children) {
    t3 = children ? <div className={styles["helios-program-cost__body"]}>{children}</div> : null;
    $[4] = children;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== table) {
    t4 = table ? <div className={styles["helios-program-cost__table"]}>{table}</div> : null;
    $[6] = table;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fineprint) {
    t5 = fineprint ? <div className={styles["helios-program-cost__fineprint"]}>{fineprint}</div> : null;
    $[8] = fineprint;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={styles["helios-program-cost"]} data-helios-program-cost="">{t2}{t3}{t4}{t5}</div>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(item, index) {
  return <div className={styles["helios-program-cost__row"]} key={index}><dt className={styles["helios-program-cost__label"]}>{item.label}</dt><dd className={styles["helios-program-cost__value"]}>{item.value}</dd></div>;
}
export default ProgramCost;